import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  && {
    display: flex;
    background: transparent;
    height: 16px;
    box-sizing: border-box;
    margin: 0;

    ${props => props.withBadges && css`
      padding: 0 3px 0 6px;
      border-radius: 8px;
      background-color: ${colors.secondary80};
    `}
  }

`

const MultiValueContainer = (props) => {
  const { withBadges } = props.selectProps

  return (
    <StyledWrapper {...props.innerProps} withBadges={withBadges}>
      {props.children}
    </StyledWrapper>
  )
}

MultiValueContainer.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object,
}

export default MultiValueContainer
